// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Load indicator */
#loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all ease-in-out 0.5s;
  background: white;
  z-index: 10000;
}

#loading.fadeout {
  opacity: 0;
  visibility: hidden;
}

#loading .cubes {
  width: 200px;
  height: 200px;
  margin: 200px auto;
}

#loading .cube {
  width: 33%;
  height: 33%;
  background-color: #05326e;
  float: left;
  animation: cubeGridScaleDelay 1.3s infinite ease-in-out;
}

#loading .cube1 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

#loading .cube2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

#loading .cube3 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

#loading .cube4 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

#loading .cube5 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

#loading .cube6 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

#loading .cube7 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

#loading .cube8 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

#loading .cube9 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

@keyframes cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }

  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/loading/LoadingIndicator.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF","sourcesContent":["/* Load indicator */\n#loading {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transition: all ease-in-out 0.5s;\n  background: white;\n  z-index: 10000;\n}\n\n#loading.fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n\n#loading .cubes {\n  width: 200px;\n  height: 200px;\n  margin: 200px auto;\n}\n\n#loading .cube {\n  width: 33%;\n  height: 33%;\n  background-color: #05326e;\n  float: left;\n  animation: cubeGridScaleDelay 1.3s infinite ease-in-out;\n}\n\n#loading .cube1 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n#loading .cube2 {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n#loading .cube3 {\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n#loading .cube4 {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n#loading .cube5 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n#loading .cube6 {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n#loading .cube7 {\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n#loading .cube8 {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n#loading .cube9 {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n@keyframes cubeGridScaleDelay {\n  0%,\n  70%,\n  100% {\n    -webkit-transform: scale3D(1, 1, 1);\n    transform: scale3D(1, 1, 1);\n  }\n\n  35% {\n    -webkit-transform: scale3D(0, 0, 1);\n    transform: scale3D(0, 0, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
